import React from "react";
import CreateContentField from "./CreateContentField";
import { Box, Card, TextField } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { PastDrawsModel } from "../../../types/generalContent";
import { CollapseState } from "../GeneralContent";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";

interface PastDrawsCardsProps {
  state: PastDrawsModel;
  collapseState: CollapseState;
  toggleCard: (name: string) => void;
  errors: Record<string, string>;
  handleChange: (e: any) => void;
  handleAddInfoDescription: (name: string, category: string) => void;
  handleRemovePastDrawsImage: (i: number) => void;
}

const PastDrawsCards = ({
  state,
  collapseState,
  toggleCard,
  errors,
  handleChange,
  handleAddInfoDescription,
  handleRemovePastDrawsImage,
}: PastDrawsCardsProps) => {
  return (
    <div className="content__section">
      <Box className="content__box">
        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.pastDrawsImages ? "open" : "close"
            }`}
            onClick={() => toggleCard("pastDrawsImages")}
          >
            Past Draws Images
          </span>
          <Collapse in={collapseState.pastDrawsImages}>
            <div className="content__fields-row centered">
              <span className="content__item-label">
                image URLs ({state.images.length}):
              </span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `pastDraws.images[${state.images.length}]`,
                    "description",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.images.map((imageUrl, i) => {
              return (
                <div className="content__fields-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle={`Image URL ${i + 1}:`}
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`pastDraws.images[${i}]`}
                            error={!!errors[`pastDraws.images[${i}]`]}
                            helperText={errors[`pastDraws.images[${i}]`]}
                            onChange={handleChange}
                            value={imageUrl}
                          />
                        </Box>
                      }
                    />
                    <button
                      className="content__delete-btn centered"
                      type="button"
                      onClick={() => handleRemovePastDrawsImage(i)}
                    >
                      <RemoveIcon />
                    </button>
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>
      </Box>
    </div>
  );
};

export default PastDrawsCards;
